import translate from '../language/translate';

// From https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions#escaping
export function escapeRegExp(value: string) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
}

export function prettyPrintList(values: string[]) {
  if (values.length >= 2) {
    return `${values.slice(0, values.length - 1).join(', ')}${values.length > 2 ? ',' : ''} ${translate('Global.AND')} ${values[values.length - 1]}`;
  }
  return values[0];
}

export const stringEmpty = (str: string): boolean => !str || str.length === 0;
